import type { RouteRecordItem } from '../types'

// 登陆后可访问的基本路由
export const basicRoutes: RouteRecordItem = {
  path: '',
  name: 'Root',
  component: () => import('@/layout/BaseLayout/index.vue'),
  children: [
    /**
     * 个人中心
     */
    {
      path: '/UserCenter',
      name: 'UserCenter',
      component: () => import('@/views/UserCenter/index.vue')
    },
    /**
     * 站内消息
     * @param type 消息类型 (0:全部类型 1:未读消息 2:已读消息)
     */
    {
      path: 'SystemMessage/:type?',
      name: 'SystemMessage',
      component: () => import('@/views/Message/SystemMessage/index.vue'),
      meta: { title: '站内消息' }
    },
    /**
     * 站内消息-详情
     * @param id 消息id
     */
    {
      path: 'SystemMessageDetail/:id',
      name: 'SystemMessageDetail',
      component: () => import('@/views/Message/SystemMessage/detail.vue'),
      meta: { title: '站内消息-详情' }
    }
  ]
}
